import { listingIcons } from './workflowMarketplace.constants';

const DEFAULT_REQUIREMENTS = [
  { title: 'Ontraccr Account', value: true },
  { title: 'Admin Permissions', value: 'isAdmin' },
];

export const getImportModalComponents = (components = []) => {
  const importComponents = [];
  components.forEach((component) => {
    switch (component.type) {
      case 'forms':
        importComponents.push('Forms and templates');
        importComponents.push('Automated workflows and rules');
        break;
      case 'boards':
        importComponents.push('Custom boards and views');
        break;
      case 'customFields':
        importComponents.push('Custom fields');
        break;
      default:
        break;
    }
  });
  return importComponents;
};

export const decorateListing = (workflow = {}) => {
  const categories = workflow.categories || [];
  const iconKey = workflow.iconKey || 'boards';
  return {
    ...workflow,
    shortDescription: workflow.shortDescription || '',
    longDescription: workflow.longDescription || '',
    color: workflow.color || '#DBEAFE',
    iconKey,
    icon: listingIcons[iconKey] || listingIcons.boards,
    commonUseCases: workflow.commonUseCases || [],
    components: workflow.components || [],
    automations: workflow.automations || [],
    requirements: workflow.requirements || DEFAULT_REQUIREMENTS,
    categories,
    categoryIds: workflow.categoryIds || [],
    categorySet: new Set(categories),
    resources: workflow.resources || [],
    status: workflow.status || 'published',
  };
};

export const getVideoEmbed = (url = '') => {
  const trimmed = (url || '').trim();
  const youtube = trimmed.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (youtube) {
    const id = youtube[1];
    return {
      provider: 'youtube',
      embedUrl: `https://www.youtube.com/embed/${id}?autoplay=1`,
      externalUrl: null,
      thumbnailUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
    };
  }
  const vimeo = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) {
    const id = vimeo[1];
    return {
      provider: 'vimeo',
      embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1`,
      externalUrl: null,
      thumbnailUrl: null,
    };
  }

  let externalUrl = null;
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      externalUrl = parsed.href;
    }
  } catch (err) {
    // Not a navigable URL — do not embed or link.
  }

  return {
    provider: 'external',
    embedUrl: null,
    externalUrl,
    thumbnailUrl: null,
  };
};
